import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";

import { useAuth } from "../../context/AuthContext";
import { useWebSocket } from "../../context/WebSocketContext";

import AnnouncementsApi from "../../api_calls/AnnouncementsApi";

import dashboardStyles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

const useStyles = makeStyles({
  ...dashboardStyles,
  card: {
    marginTop: "0",
    paddingTop: "0",
  },
  cardHeaderPlain: {
    padding: "10px",
    margin: "0",
  },
  cardTitleBlack: {
    color: "#000000",
    marginTop: "0",
    marginBottom: "5px",
    fontWeight: "500",
    fontSize: "1.25rem",
  },
  cardCategoryBlack: {
    color: "#555555",
    margin: "0",
    fontSize: "0.875rem",
  },
  buttonOrange: {
    backgroundColor: "#d76213",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#c15610",
    },
  },
  textField: {
    marginTop: "8px",
    marginBottom: "8px",
  },
  announcementItem: {
    marginBottom: "15px",
    padding: "10px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    backgroundColor: "#fafafa",
  },
  announcementName: {
    fontWeight: 500,
    fontSize: "0.95rem",
  },
  announcementTime: {
    color: "#777",
    fontSize: "0.8rem",
  },
  announcementText: {
    marginTop: "5px",
  },
});

export default function Announcement() {
  const classes = useStyles();
  const { sendMessage } = useWebSocket();
  const { user } = useAuth();
  const userId = user?.user_id || "";
  const [announcementText, setAnnouncementText] = useState("");
  const [announcements, setAnnouncements] = useState([]);

  const handleChange = (event) => {
    setAnnouncementText(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendMessage({
      user_id: userId,
      tag: "announcement",
      payload: { announcement_text: announcementText },
    });
    setAnnouncementText("");
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await AnnouncementsApi.fetchAnnouncements();
      console.log("Received announcements:", result);
      if (result.status === "success" && Array.isArray(result.data)) {
        setAnnouncements(result.data);
      } else {
        console.error("Unexpected announcements format:", result);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Card className={classes.card}>
        <CardHeader className={classes.cardHeaderPlain}>
          <h4 className={classes.cardTitleBlack}>Create New Announcement</h4>
          <p className={classes.cardCategoryBlack}>
            Draft and publish messages for your users.
          </p>
        </CardHeader>
        <form onSubmit={handleSubmit}>
          <CardBody>
            <TextField
              label="Type your announcement"
              multiline
              rows={5}
              fullWidth
              variant="outlined"
              value={announcementText}
              onChange={handleChange}
              required
              className={classes.textField}
              placeholder="Type your announcement here..."
            />
          </CardBody>
          <CardFooter>
            <Tooltip
              title="Publish your announcement to all users"
              placement="top"
            >
              <Button type="submit" className={classes.buttonOrange}>
                Publish Announcement
              </Button>
            </Tooltip>
          </CardFooter>
        </form>
      </Card>

      <Card style={{ marginTop: "20px" }}>
        <CardHeader className={classes.cardHeaderPlain}>
          <h4 className={classes.cardTitleBlack}>Previous Announcements</h4>
        </CardHeader>
        <CardBody>
          {announcements.length === 0 ? (
            <p>No announcements yet.</p>
          ) : (
            announcements.map((ann, index) => (
              <div key={index} className={classes.announcementItem}>
                <div className={classes.announcementName}>
                  {ann.first_name} {ann.other_names}
                </div>
                <div className={classes.announcementTime}>
                  {new Date(ann.created_at).toLocaleString()}
                </div>
                <div className={classes.announcementText}>{ann.message}</div>
              </div>
            ))
          )}
        </CardBody>
      </Card>
    </>
  );
}
